<div class="col-12 col-sm-6 col-md-4">
    <label>Nome medicamento: </label>
    <p>{{prescriptionMedicine.medicineName}}</p>
</div>
<div class="row row-block">
    <div class="col-12 col-sm-6 col-md-4">
        <label>Quantidade: </label>
        <p>{{prescriptionMedicine.prescriptionMedicine.quantity}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Dose a ser administrada: </label>
        <p>{{prescriptionMedicine.doseToAdministeredName}}</p>
    </div>
</div>
<div class="row row-block">
    <div class="col-12 col-sm-6 col-md-4">
        <label>Unidade: </label>
        <p>{{prescriptionMedicine.measurementUnitName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Local de administração: </label>
        <p>{{prescriptionMedicine.lookupAdministrationLocationName}}</p>
    </div>
</div>
<div class="row row-block">
    <div class="col-12 col-sm-6 col-md-4">
        <label>Apresentação: </label>
        <p>{{prescriptionMedicine.presentationName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Uso: </label>
        <p>{{prescriptionMedicine.usage}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Forma de consumo:</label>
        <p>{{prescriptionMedicine.administrationTypeName}}</p>
        <p>{{prescriptionMedicine.prescriptionMedicine.administrationType}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Frequencia: </label>
        <p>{{prescriptionMedicine.frequencyName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Período de tratamento: </label>
        <p>{{prescriptionMedicine.treatmentPeriodName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Diluição: </label>
        <p>{{prescriptionMedicine.prescriptionMedicine.dilution ? prescriptionMedicine.prescriptionMedicine.dilution :
            prescriptionMedicine.dilutionName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Observação: </label>
        <p>{{prescriptionMedicine.prescriptionMedicine.observation}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Unidade de diluição: </label>
        <p>{{prescriptionMedicine.dilutionUnitName}}</p>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
        <label>Quantidade de diluição: </label>
        <p>{{prescriptionMedicine.prescriptionMedicine.dilutionQuantity}}</p>
    </div>
</div>